import React, { useEffect, useState } from 'react';
import {
  TEST_DATA,
} from '../../components/FileManager/PdfGenerator';
import PdfViewer from '../../components/FileManager/PdfViewer';
import { useRenderQuotePdf } from '../../hooks/useRenderQuotePdf';

// NOTE: that this object must be declared OUTSIDE the component
const props = { data: TEST_DATA };

const TestPdfPage = () => {
  // const worker = useRenderQuotePdfWorker();

  // const [loading, setLoading] = useState(false);
  // const [url, setUrl] = useState<string | null>(null);

  // useEffect(() => {
  //   setLoading(true);
  //   worker?.call({ props: { data: TEST_DATA } }).then(({ url }) => {
  //     setUrl(url);
  //   }).finally(() => setLoading(false));
  // }, [worker]);

  // useEffect(() => {
  //   return () => {
  //     if (url) {
  //       URL.revokeObjectURL(url);
  //     }
  //   };
  // }, [url]);

  const {url} = useRenderQuotePdf(props);

  return (
    <>
      {url ? (
        <>
          <a href={url} target='_blank' rel='noreferrer'>
            Open
          </a>
          <PdfViewer url={url} />
        </>
      ) : null}
      {/* <PDFDownloadLink
        document={<PdfGenerator data={TEST_DATA} />}
        fileName='estimate'
      >
        {({ loading, error }) =>
          error ? error.message : loading ? 'Loading...' : 'Download now!'
        }
      </PDFDownloadLink>
      <PDFViewer style={{width: '100%', height: '100%'}} showToolbar={false}>
        <PdfGenerator data={TEST_DATA} />
      </PDFViewer> */}
    </>
  );
};

export default TestPdfPage;
